<div *ngIf="showRevisionInfo">{{ branch }}::{{ revision }}::{{ datetime }}</div>
